import { Field } from './field';
import { Stable } from './stable';

export class LandRegistry {
  id: number;
  country: string;
  companyId: number;
  town: string;
  cadastralSheet: string;
  landParcel: string;
  cadastralArea: string;
  ownerName: string;
  managementType: string;
  usedArea: string;
  pac: string;
  field: Field;
  stable: Stable;
  subLandParcel: string;
  identification: string;
  useType: string;
  ibgeCode?: string;
  federalUnit?: string;
  carRegistrationNumber?: string;
  registrationStatus?: string;
  propertyType?: string;
  fiscalModules?: string;
}

export const REGISTRY_MANAGEMENT_TYPES = {
  OWNERSHIP: 'ownership',
  RENT: 'rent',
  COOWNERSHIP: 'coownership',
  CONCESSIONS: 'concessions',
  PROFIT_SHARE: 'profit_share',
  BARTER: 'barter',
  GIVEN_FOR_RENT: 'given_for_rent',
  GIVEN_IN_TRADE_IN: 'given_in_trade_in',
  LOAN_FOR_USE: 'loan_for_use',
};
/*
*********** MODELLO DI BACKEND **********************
package com.xfarm.api.v1.core

import com.xfarm.api.v1.auth.User

class LandRegistry {
    transient springSecurityService

    Long   companyId = -1
    string country
    string town
    string cadastralSheet
    string landParcel
    string cadastralArea
    string ownerName
    string managementType
    string pac

    Date        dateCreated
    Date        lastUpdated

    static belongsTo    = [field: Field]

    static constraints = {
        companyId          blank: false, nullable: false
        country            blank: false, nullable: true
        town               blank: false, nullable: true
        cadastralSheet     blank: false, nullable: false
        landParcel         blank: false, nullable: false
        cadastralArea      blank: false, nullable: true
        ownerName          blank: false, nullable: true
        managementType     blank: false, nullable: true
        pac                blank: false, nullable: true
        field validator: { val, obj ->
            if(obj.companyId != val.companyId){
                return false
            }
            return true
        }
    }

    static mapping = {
        autoTimestamp true
    }

    def beforeUpdate() {
        if(companyId != User.get(springSecurityService?.principal?.id)?.farm?.id){
            return false
        }
    }

    def beforeValidate() {
        if(companyId == -1){
            companyId = User.get(springSecurityService?.principal?.id)?.farm?.id
        }
    }

    static transients = ['springSecurityService']
}

*/
